import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent$key } from '@atlassian/jira-relay/src/__generated__/popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent.graphql.ts';
import { type Props, HoverPopoverWithContext } from './popover-with-context/index.tsx';
import { HoverPopoverWithRelay } from './popover-with-relay/index.tsx';

// Re-exporting here is temporary to allow for a smooth transition to the relay hover popover.
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	type Props,
	HoverPopoverWithContext,
	CellHoverRenderer,
	type CellHoverRendererProps,
} from './popover-with-context/index.tsx';

export const HoverPopover = <T extends HTMLElement>(
	props: Props<T> & {
		fragmentRef?: popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent$key | null;
	},
) => {
	if (fg('issue_table_single_line_row_height_event_delegator')) {
		return <HoverPopoverWithRelay<T> {...props} />;
	}

	const { fragmentRef, ...rest } = props;

	return <HoverPopoverWithContext<T> {...rest} />;
};
